<section *ngIf="feature.enabled" class="map-control-surface prospect-legend" aria-label="Lead Discovery coverage legend">
  <strong>Lead Discovery</strong>
  <div class="coverage-keys">
    <span class="coverage-key" *ngFor="let style of feature.coverageStyles">
      <span class="coverage-swatch" aria-hidden="true" [style.color]="style.color" [style.background]="
        'repeating-linear-gradient(' + style.angle + 'deg, transparent, transparent 5px, ' + style.color + ' 5px, ' + style.color + ' 7px)'"></span>
      {{ style.label }}
    </span>
  </div>
  <p class="coverage-note">Unmarked = no recorded successful pull.</p>
  <p *ngIf="feature.coverageMessage" class="coverage-note" role="status">{{ feature.coverageMessage }}</p>
</section>
